module.exports = __webpack_public_path__ + "assets/a5002bcdba53b6fdd5ebbdcf7ee67769.mp3";